<template>
    <el-dialog title="投诉质疑" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false"
        :close-on-press-escape="false" @close="handleClose" :append-to-body="true">
        <el-form ref="complainForm" :model="formData" :rules="rules" label-width="120px" label-position="left">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="项目编号" prop="projectCode">
                        <el-input v-model="formData.projectCode" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="标段编号" prop="bidSectionCode">
                        <el-input v-model="formData.bidSectionCode" disabled />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="标段名称" prop="bidSectionName">
                        <el-input v-model="formData.bidSectionName" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投诉类型" prop="complaintType">
                        <el-select v-model="formData.complaintType" placeholder="请选择投诉类型" disabled>
                            <el-option label="对文件的质疑" value="bidDoc" />
                            <el-option label="对评标结果投诉" value="bidResult" />
                            <el-option label="对开标过程质疑" value="bidOpen" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="标题" prop="title">
                <el-input v-model="formData.title" placeholder="请输入投诉质疑标题" maxlength="100" show-word-limit />
            </el-form-item>
            <el-form-item label="依据" prop="accordingTo">
                <el-input v-model="formData.accordingTo" type="textarea" :rows="3" placeholder="请输入投诉质疑依据"
                    maxlength="500" show-word-limit />
            </el-form-item>
            <el-form-item label="内容" prop="content">
                <el-input v-model="formData.content" type="textarea" :rows="5" placeholder="请详细描述投诉质疑内容"
                    maxlength="2000" show-word-limit />
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input v-model="formData.remark" type="textarea" :rows="3" placeholder="请输入备注信息（选填）" maxlength="500"
                    show-word-limit />
            </el-form-item>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="提交单位名称" prop="submitUserName">
                        <el-input v-model="formData.submitUserName" placeholder="请输入提交单位名称" maxlength="100" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="联系人" prop="submitContact">
                        <el-input v-model="formData.submitContact" placeholder="请输入联系人姓名" maxlength="50" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="联系电话" prop="submitPhone">
                <el-input v-model="formData.submitPhone" placeholder="请输入联系人手机号码" maxlength="11" />
            </el-form-item>
            <el-form-item label="相关附件">
                <div class="upload-section">
                    <div class="upload-container">
                        <el-button type="primary" @click="handleSelectFile">选择文件</el-button>
                        <input type="file" ref="fileInput" style="display: none" multiple @change="handleFileChange" />
                        <span class="upload-tip">支持上传多个文件，单个文件大小不超过50MB，支持格式：pdf、doc、docx、xls、xlsx、jpg、png等</span>
                    </div>
                    <div v-if="fileList.length > 0" class="file-list">
                        <div v-for="(file, index) in fileList" :key="index" class="file-item">
                            <span class="file-name">{{ file.name }}</span>
                            <el-progress v-if="file.uploading" :percentage="file.progress"></el-progress>
                            <span v-if="file.uploaded" class="file-status success">已上传</span>
                            <el-button type="text" @click="removeFile(index)">删除</el-button>
                        </div>
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <!-- <el-button type="info" @click="handleSave(0)" :loading="saveLoading">
                暂存
            </el-button> -->
            <el-button type="primary" @click="handleSave(1)" :loading="submitLoading">
                提交
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { doFileUpload } from '@/utils/fileUploadHelper'
import { createComplain } from '@/api/createComplain/api'

export default {
    name: 'ComplainDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        // 外部传入的基础数据
        projectCode: {
            type: String,
            default: ''
        },
        bidSectionCode: {
            type: String,
            default: ''
        },
        bidSectionName: {
            type: String,
            default: ''
        },
        complaintType: {
            type: String,
            default: ''
        },
        // 编辑时传入的数据
        editData: {
            type: Object,
            default: () => ({})
        },
        fileBindId: {
            type: String,
            default: () => ({})
        }
    },
    data() {
        return {
            dialogVisible: false,
            saveLoading: false,
            submitLoading: false,
            formData: {
                accordingTo: '',
                bidSectionCode: '',
                bidSectionName: '',
                complaintType: '',
                content: '',
                projectCode: '',
                remark: '',
                status: 0,
                submitContact: '',
                submitFileGuid: '',
                submitPhone: '',
                submitUserName: '',
                title: ''
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题'},
                    { min: 1, max: 100, message: '标题长度在1到100个字符' }
                ],
                accordingTo: [
                    { required: true, message: '请输入依据' },
                    { max: 500, message: '依据长度不能超过500个字符' }
                ],
                content: [
                    { required: true, message: '请输入内容' },
                    { max: 2000, message: '内容长度不能超过2000个字符' }
                ],
                submitUserName: [
                    { required: true, message: '请输入提交单位名称' },
                    { max: 100, message: '单位名称长度不能超过100个字符' }
                ],
                submitContact: [
                    { required: true, message: '请输入联系人' },
                    { max: 50, message: '联系人姓名长度不能超过50个字符' }
                ],
                submitPhone: [
                    { required: true, message: '请输入联系电话' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码' }
                ]
            },
            fileList: []
        }
    },
    watch: {
        visible: {
            handler(val) {
                this.dialogVisible = val
                if (val) {
                    this.initFormData()
                }
            },
            immediate: true
        }
    },
    methods: {
        // 初始化表单数据
        initFormData() {
            // 设置基础数据
            this.formData = {
                accordingTo: this.editData.accordingTo || '',
                bidSectionCode: this.bidSectionCode,
                bidSectionName: this.bidSectionName,
                complaintType: this.complaintType,
                content: this.editData.content || '',
                projectCode: this.projectCode,
                remark: this.editData.remark || '',
                status: 0,
                submitContact: this.editData.submitContact || '',
                submitFileGuid: this.fileBindId || this.editData.submitFileGuid || '',
                submitPhone: this.editData.submitPhone || '',
                submitUserName: this.editData.submitUserName || '',
                title: this.editData.title || ''
            }


            // 如果是编辑模式，加载已有文件列表
            if (this.editData.fileList) {
                this.fileList = this.editData.fileList.map(file => ({
                    name: file.fileName || file.name,
                    size: file.size || 0,
                    uploading: false,
                    uploaded: true,
                    progress: 100,
                    fileGuid: file.fileGuid || '',
                    uploadFileId: file.uploadFileId || file.fileId,
                    filePath: file.filePath || file.fileUrl
                }))
            } else {
                this.fileList = []
            }

            // 清除表单验证
            this.$nextTick(() => {
                if (this.$refs.complainForm) {
                    this.$refs.complainForm.clearValidate()
                }
            })
        },

        // 选择文件
        handleSelectFile() {
            this.$refs.fileInput.click()
        },

        // 文件选择变化
        async handleFileChange(event) {
            const files = Array.from(event.target.files)
            if (files.length === 0) return

            for (const file of files) {
                // 检查文件类型和大小
                if (!this.checkFileType(file.name)) {
                    this.$message.error(`文件 ${file.name} 格式不正确！`)
                    continue
                }
                if (file.size / 1024 / 1024 > 50) {
                    this.$message.error(`文件 ${file.name} 大小不能超过50MB！`)
                    continue
                }

                const fileItem = {
                    name: file.name,
                    size: file.size,
                    uploading: true,
                    uploaded: false,
                    progress: 0,
                    fileGuid: '',
                    uploadFileId: '',
                    filePath: ''
                }
                this.fileList.push(fileItem)

                try {
                    const result = await doFileUpload(file, {
                        fileBindId: this.formData.submitFileGuid,
                        onProgress: (percentage) => {
                            fileItem.progress = percentage
                        },
                        onSuccess: (res) => {
                            fileItem.uploading = false
                            fileItem.uploaded = true
                            fileItem.fileGuid = res.fileGuid
                            fileItem.uploadFileId = res.uploadFileId
                            fileItem.filePath = res.filePath
                            this.$message.success(`文件 ${file.name} 上传成功`)
                        },
                        onError: (error) => {
                            fileItem.uploading = false
                            this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`)
                        }
                    })
                } catch (error) {
                    fileItem.uploading = false
                    this.$message.error(`文件 ${file.name} 上传失败`)
                }
            }

            // 清空input
            event.target.value = ''
        },

        // 检查文件类型
        checkFileType(fileName) {
            const allowedTypes = [
                '.pdf', '.doc', '.docx', '.xls', '.xlsx',
                '.ppt', '.pptx', '.txt', '.jpg', '.jpeg',
                '.png', '.gif', '.bmp', '.zip', '.rar'
            ]
            const fileExt = fileName.toLowerCase().substring(fileName.lastIndexOf('.'))
            return allowedTypes.includes(fileExt)
        },

        // 删除文件
        removeFile(index) {
            this.$confirm('确定要删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fileList.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => { })
        },

        // 保存/提交
        async handleSave(status) {
            try {
                // 表单验证
                const valid = await this.$refs.complainForm.validate()
                if (!valid) return

                // 设置状态和loading
                this.formData.status = status
                if (status === 0) {
                    this.saveLoading = true
                } else {
                    this.submitLoading = true
                }

                // 构建提交数据
                const submitData = {
                    ...this.formData,
                    status
                }
                this.createComplain()


            } catch (error) {
                console.error('Save error:', error)
                this.$message.error('操作失败，请重试')
            } finally {
                this.saveLoading = false
                this.submitLoading = false
            }
        },
        // 保存质疑
        createComplain(submitData) {
            createComplain(this.complaintType, this.formData).then(res => {
                if (res.code === 200) {
                    this.$emit('save', submitData)

                }
            })
        },

        // 关闭弹窗
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')

            // 重置表单
            this.$nextTick(() => {
                if (this.$refs.complainForm) {
                    this.$refs.complainForm.resetFields()
                }
                this.fileList = []
                this.saveLoading = false
                this.submitLoading = false
            })
        },

        // 保存成功后的处理
        handleSaveSuccess() {
            this.saveLoading = false
            this.submitLoading = false
            this.handleClose()
        },

        // 保存失败后的处理
        handleSaveError() {
            this.saveLoading = false
            this.submitLoading = false
        }
    }
}
</script>

<style lang="less" scoped>
.upload-section {
    .upload-container {
        margin-bottom: 15px;

        .upload-tip {
            color: #999;
            font-size: 12px;
            line-height: 1.4;
            margin-left: 10px;
        }
    }

    .file-list {
        border: 1px solid #e4e7ed;
        border-radius: 4px;
        padding: 10px;
        background-color: #fafafa;

        .file-item {
            display: flex;
            align-items: center;
            padding: 8px 0;
            border-bottom: 1px solid #e4e7ed;

            &:last-child {
                border-bottom: none;
            }

            .file-name {
                flex: 1;
                color: #606266;
                font-size: 14px;
                margin-right: 10px;
                word-break: break-all;
            }

            .el-progress {
                flex: 1;
                margin: 0 10px;
            }

            .file-status {
                margin-right: 10px;
                font-size: 12px;

                &.success {
                    color: #67c23a;
                }
            }

            .el-button--text {
                color: #f56c6c;

                &:hover {
                    color: #f78989;
                }
            }
        }
    }
}

.dialog-footer {
    text-align: right;

    .el-button {
        margin-left: 10px;
    }
}

/deep/ .el-dialog {
    .el-dialog__header {
        background-color: #f5f7fa;
        border-bottom: 1px solid #e4e7ed;

        .el-dialog__title {
            font-weight: 600;
            color: #303133;
        }
    }

    .el-dialog__body {
        padding: 30px 20px;
    }

    .el-form-item__label {
        font-weight: 500;
        color: #606266;
    }
}

/deep/ .el-textarea__inner {
    resize: vertical;
    min-height: 80px;
}

/deep/ .el-upload-list {
    max-height: 200px;
    overflow-y: auto;
}
</style>